export const getTaxonomiesMessage = (codename: string, strs: Record<string, string>) => {
  return strs[codename] ?? '';
};
